import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../lib/api-client';
import type { EnrollmentStatus } from '@lms/shared/types';

export const enrollmentKeys = {
  all: ['enrollments'] as const,
  lists: () => [...enrollmentKeys.all, 'list'] as const,
  list: (params: Record<string, unknown>) => [...enrollmentKeys.all, 'list', params] as const,
  details: () => [...enrollmentKeys.all, 'detail'] as const,
  detail: (id: string) => [...enrollmentKeys.details(), id] as const,
};

export function useEnrollments(params?: { userId?: string; programId?: string }) {
  return useQuery({
    queryKey: enrollmentKeys.list(params || {}),
    queryFn: () => apiClient.enrollments.list(params),
  });
}

export function useEnrollmentPage(params: {
  page: number;
  limit?: number;
  userId?: string;
  programId?: string;
  search?: string;
  status?: EnrollmentStatus;
}) {
  return useQuery({
    queryKey: enrollmentKeys.list(params),
    queryFn: () => apiClient.enrollments.listPage(params),
  });
}

export function useEnrollment(id: string) {
  return useQuery({
    queryKey: enrollmentKeys.detail(id),
    queryFn: () => apiClient.enrollments.get(id),
    enabled: !!id,
  });
}
